import React, { useEffect } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import useCoordinatesStore from "@/lib/coordinates-store";
import useFormStore from "@/lib/FormZustand";

const icon = L.icon({
  iconUrl: "/pin-icon.svg",
  iconSize: [38, 38],
});

// Set the default center to roughly the midpoint between Aachen and Eschweiler
const defaultCenter = [50.78, 6.09];
const defaultZoom = 13;


function ResetCenterView({ coordinates, start }) {
   const map = useMap();
  
   useEffect(() => {
    // Check if the coordinates object exists AND if both lat and lng properties are numbers
      // Using typeof 'number' is safer than just checking for defined/null if non-numeric values are possible
      if (start==="") {
        return;
      }else{
      setTimeout(()=>{
      if (coordinates) {
        // Only attempt to fly if we have valid lat and lng numbers
        map.flyTo(L.latLng(coordinates.lat, coordinates.lng), 15, {
         animate: true,
         duration: 2,
        });
       }
    },500)
  }
   }, [coordinates, start]); // Effect dependency is the 'coordinates' object
  
   return null;
  }

export default function Maps() {
  const { coordinates } = useCoordinatesStore();
  const { formData } = useFormStore();
  const locationSelection = [coordinates.lat, coordinates.lng];
  return (
    <MapContainer
      center={defaultCenter}
      zoomControl={false}
      zoom={defaultZoom}
      style={{ width: "100%", height: "100%", zIndex: 0 }}
    >
      <TileLayer
        attribution='&copy; <a className="hidden" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://tile.jawg.io/dfbe15c6-374e-4f04-92c0-5c9678cd7132/{z}/{x}/{y}{r}.png?access-token=aIs4QlE6wRbH35AB9YspWkO82STp4zrWRwcuEkmwWFgJ4WhsEqThj2fsGhCT7g7w"
      />
      {locationSelection && formData.city!="" &&(
        <Marker position={locationSelection} icon={icon}>
          <Popup>
          {formData.city || "" }
          </Popup>
        </Marker>
      )}
      <ResetCenterView start={formData.city} coordinates={coordinates} />
    </MapContainer>
  );
}
